import { motion } from "framer-motion";

const statusStyle = {
  available: "bg-emerald-50 border-emerald-500 text-emerald-800 hover:bg-emerald-100",
  reserved: "bg-amber-50 border-amber-500 text-amber-700 hover:bg-amber-100",
  sold: "bg-rose-100 border-rose-400 text-rose-700 line-through",
};

export default function PlotBoard({ plots, interactive = false, onToggle, busyNumber, pulseNumbers }) {
  const isPulsing = (n) => !!(pulseNumbers && pulseNumbers.has && pulseNumbers.has(n));
  return (
    <div className="grid grid-cols-[repeat(auto-fill,minmax(46px,1fr))] gap-2" data-testid="plot-board">
      {plots.map((p) => {
        const disabled = busyNumber === p.number;
        const pulsing = isPulsing(p.number);
        const base = "relative flex h-11 items-center justify-center rounded-sm border text-sm font-500 transition-colors duration-200";
        const clickable = interactive ? "cursor-pointer" : "cursor-default";
        return (
          <motion.button
            key={p.number}
            type="button"
            disabled={!interactive || disabled}
            onClick={() => interactive && onToggle && onToggle(p)}
            animate={pulsing ? { scale: [1, 1.28, 1] } : { scale: 1 }}
            transition={pulsing ? { duration: 0.6, repeat: 3, ease: "easeInOut" } : { duration: 0.2 }}
            whileHover={interactive ? { y: -2 } : {}}
            className={`${base} ${statusStyle[p.status]} ${clickable} ${disabled ? "opacity-50" : ""}`}
            title={`Plot ${p.number}${p.is_odd ? " (Odd Site)" : ""} — ${p.status}`}
            data-testid={`plot-chip-${p.number}`}
          >
            {p.number}
            {p.is_odd && <span className="absolute right-0.5 top-0 text-[9px] text-[var(--gold-hover)]">*</span>}
            {pulsing && (
              <span className="pointer-events-none absolute inset-0 rounded-sm border-2 border-[var(--gold)] animate-ping" />
            )}
          </motion.button>
        );
      })}
    </div>
  );
}

export const PlotLegend = ({ available, reserved, sold }) => (
  <div className="flex flex-wrap items-center gap-5 text-sm" data-testid="plot-legend">
    <span className="flex items-center gap-2">
      <span className="h-3.5 w-3.5 rounded-sm border border-emerald-500 bg-emerald-50" />
      Available <strong className="text-[var(--ink)]">{available}</strong>
    </span>
    <span className="flex items-center gap-2">
      <span className="h-3.5 w-3.5 rounded-sm border border-amber-500 bg-amber-50" />
      Reserved <strong className="text-[var(--ink)]">{reserved}</strong>
    </span>
    <span className="flex items-center gap-2">
      <span className="h-3.5 w-3.5 rounded-sm border border-rose-400 bg-rose-100" />
      Sold <strong className="text-[var(--ink)]">{sold}</strong>
    </span>
    <span className="flex items-center gap-2 text-[var(--ink-soft)]">
      <span className="text-[var(--gold-hover)]">*</span> Odd Site
    </span>
  </div>
);
